import React from "react";
import PlainCard from "./plainCard";

// import data from "./data"
import "./style.scss";

const PlainCards = ({ data, parentCategory, blockMode }) => (
  <div className="accounts-row__wrap">
    <div className="accounts-row accounts-row--three-items filter-list">
      {data.map((item) => (
        <PlainCard
          {...item}
          parentCategory={parentCategory}
          blockMode={blockMode}
        />
      ))}
    </div>
  </div>
);

export default PlainCards;
